import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-spend-limit',
  templateUrl: './spend-limit.component.html',
  styleUrls: ['./spend-limit.component.scss']
})
export class SpendLimitComponent implements OnInit {
  public redirect = environment.applyRedirect;
  constructor() { }

  ngOnInit(): void {
  }

}
